import {index} from '../../api/endpoints/driverNotification'
export const state = {
  data: [],
  balance: 1
}

export const getters = {
  items(state) {
    return state.data
  },
  balance(state) {
    return state.balance
  }
}

export const mutations = {
  FETCH_DATA(state, payload) {
    state.data = payload.pagination.data;
    state.balance = payload.balance;
  }
}

export const actions = {
  fetchData({commit}, params) {
    return new Promise( (resolve, reject) => {
      index({...params}).then( res => {
        commit("FETCH_DATA", res.data);
        // eslint-disable-next-line no-console
        console.log(res.data);
        resolve(res)
      }).catch( e => {
        reject(e)
      })
    })
  }
}